// Generated by purs version 0.15.15
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_String_Regex from "../Data.String.Regex/index.js";
import * as Data_String_Regex_Flags from "../Data.String.Regex.Flags/index.js";
import * as Ouroboros_Models_Brands_DocumentID from "../Ouroboros.Models.Brands.DocumentID/index.js";
import * as Ouroboros_Models_Brands_IsoTimestamp from "../Ouroboros.Models.Brands.IsoTimestamp/index.js";
import * as Ouroboros_Models_Brands_SectionID from "../Ouroboros.Models.Brands.SectionID/index.js";
import * as Ouroboros_Models_Brands_SectionIndex from "../Ouroboros.Models.Brands.SectionIndex/index.js";
import * as Ouroboros_Models_Brands_SectionStatus from "../Ouroboros.Models.Brands.SectionStatus/index.js";
var uuidPattern = "^(?:[0-9a-f]{32}|[0-9a-f]{8}-[0-9a-f]{4}-[1-7][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})$";
var isoDatePattern = "^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(?:\\.\\d{1,9})?(?:Z|[+-]\\d{2}:?\\d{2})$";
var isSectionStatus = function (value) {
    return value === "Active" || (value === "Started" || (value === "Unstarted" || value === "Error"));
};
var isNonEmpty = function (value) {
    return value !== "";
};
var isMatch = function (pattern) {
    return function (value) {
        var v = Data_String_Regex.regex(pattern)(Data_String_Regex_Flags.ignoreCase);
        if (v instanceof Data_Either.Left) {
            return false;
        };
        if (v instanceof Data_Either.Right) {
            return Data_String_Regex.test(v.value0)(value);
        };
        throw new Error("Failed pattern match at Ouroboros.Models.Documents.Documents (line 80, column 3 - line 82, column 42): " + [ v.constructor.name ]);
    };
};
var isUuid = function (value) {
    return isMatch(uuidPattern)(value);
};
var isIsoDate = function (value) {
    return isMatch(isoDatePattern)(value);
};
var validateDocumentMetadata = function (metadata) {
    return isNonEmpty(metadata.name) && (isIsoDate(Ouroboros_Models_Brands_IsoTimestamp.unwrap(metadata.last_edited)) && isUuid(Ouroboros_Models_Brands_DocumentID.unwrap(metadata.id)));
};
var validateSectionMetadata = function (metadata) {
    return isNonEmpty(metadata.name) && (Ouroboros_Models_Brands_SectionIndex.unwrap(metadata.index) >= 0.0 && (isSectionStatus(Ouroboros_Models_Brands_SectionStatus.unwrap(metadata.status)) && (isUuid(Ouroboros_Models_Brands_SectionID.unwrap(metadata.id)) && (function () {
        if (metadata.last_edited instanceof Data_Maybe.Nothing) {
            return true;
        };
        if (metadata.last_edited instanceof Data_Maybe.Just) {
            return isIsoDate(Ouroboros_Models_Brands_IsoTimestamp.unwrap(metadata.last_edited.value0));
        };
        throw new Error("Failed pattern match at Ouroboros.Models.Documents.Documents (line 112, column 8 - line 114, column 60): " + [ metadata.last_edited.constructor.name ]);
    })())));
};
var validateOutlineSection = validateSectionMetadata;
var validateSection = function (section) {
    return validateSectionMetadata(section.metadata) && (function () {
        if (section.section_contents instanceof Data_Maybe.Nothing) {
            return true;
        };
        if (section.section_contents instanceof Data_Maybe.Just) {
            return true;
        };
        throw new Error("Failed pattern match at Ouroboros.Models.Documents.Documents (line 122, column 8 - line 124, column 23): " + [ section.section_contents.constructor.name ]);
    })();
};
var validateUserDocument = function (document) {
    return isNonEmpty(document.name) && (isUuid(Ouroboros_Models_Brands_DocumentID.unwrap(document.id)) && Data_Array.all(validateSection)(document.document_contents));
};
export {
    isIsoDate,
    isNonEmpty,
    isSectionStatus,
    isUuid,
    validateDocumentMetadata,
    validateSectionMetadata,
    validateOutlineSection,
    validateSection,
    validateUserDocument
};
//# sourceMappingURL=index.js.map
